import { TextField } from '@mui/material';
import React, { useRef } from 'react';
import { useForm } from "react-hook-form";
import { translate } from '../../Helper/multilingual';
import PasswordIcon from '../../Assets/formIcons/password.svg';

import { Grid } from '@mui/material';
import Button from '../../Components/Button';
import UserUnit from '../../Services/Http/User';
import wrlog from '../../Helper/functions/wrlog';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { addMessage } from '../../Services/Redux/features/messages/messageSlice';

interface ResetPasswordFormProps {
    closePopup?: any;
    resetKey: string;
    secret: string;
}

/**
 * 
 * @returns Login Page
 */
const ResetPasswordForm = (props: ResetPasswordFormProps) => {

    const ForgotPasswordButtonRef = useRef();

    const { closePopup, resetKey, secret } = props;

    const { register, handleSubmit, formState: { errors } } = useForm();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    /**
     * Logs in the User
     * @param {object} data 
     * 
     * @returns void
     */
    const doForgotPassword = (data: any) => {
        let buttonRef = ForgotPasswordButtonRef.current || null;
        if (buttonRef !== null) {
            buttonRef.changeState('loading');
        }

        UserUnit.resetPassword(data.password, resetKey, secret).then(res => {
            buttonRef.changeState('success');

            navigate("/", { replace: true });
            setTimeout(() => {
                closePopup();
                dispatch(addMessage({
                    type: 'success',
                    title: translate('reset_password_success_title'),
                    body: translate('reset_password_success_body')
                }));
            }, 1000)

        }).catch(err => {
            wrlog(err);
            buttonRef.changeState('error');

            dispatch(addMessage({
                type: 'error',
                title: err.title,
                body: err.description
            }));

        })
    }

    return (
        <Grid container spacing={0}>
            <Grid item md={12} padding={0}>
                <h3>{translate('forgot_password')}</h3>
                <p>{translate('forgot_password_text')}</p>
                <form onSubmit={handleSubmit(doForgotPassword)}>
                    <TextField
                        {...register('password', { required: true })}
                        error={errors.password}
                        id="standard-basic"
                        label={<><img src={PasswordIcon} /><div>{translate('password')}</div></>}
                        type="password"
                        className='hasIcon dark'
                    />
                    <Button
                        type='primary'
                        isInput
                        label={translate('request_recoverylink')}
                        ref={ForgotPasswordButtonRef}
                    />
                </form>
            </Grid>
        </Grid>
    );
}

export default ResetPasswordForm;